import * as echarts from "echarts";
import Highcharts from "highcharts";
import SolidGauge from "highcharts/modules/solid-gauge.js";
import HighchartsMore from "highcharts/highcharts-more";
import { getTimeFormat } from "./helpers/common";
import store from "@/state/store";
HighchartsMore(Highcharts);
SolidGauge(Highcharts);

/* 获取当月天数 */
const getCurrentMonthDate = () => {
  let nowDate = new Date();
  let year = nowDate.getFullYear();
  let month = nowDate.getMonth() + 1;
  let dayNum = new Date(year, month, 0).getDate();
  return dayNum;
};

/* 换算伸缩比例 */
const setSize = (val, initWidth = 1920) => {
  //当前视口宽度
  var nowClientWidth =
    document.documentElement.clientWidth || window.clientWidth;

  return val * (nowClientWidth / initWidth);
};

/* 展示悬停框 */
const showTitle = (e) => {
  if (window.localStorage.getItem("language") == "en") {
    if (e.target.children[1].style.display == "none") {
      e.target.children[1].style.display = "block";
    } else {
      e.target.children[1].style.display = "none";
    }
  }
};

/* 获取浏览器默认语言 */
const getBrowserLang = function () {
  let browserLang = navigator.language
    ? navigator.language
    : navigator.browserLanguage;
  let defaultBrowserLang = "";
  if (
    browserLang.toLowerCase() === "cn" ||
    browserLang.toLowerCase() === "zh" ||
    browserLang.toLowerCase() === "zh-cn"
  ) {
    defaultBrowserLang = "zh";
  } else {
    defaultBrowserLang = "en";
  }
  return defaultBrowserLang;
};

/* VSD420折线图 */
const VSD420LineChart = (options) => {
  let {
    chartDom,
    name,
    legend,
    xData,
    yData,
    average,
    xAxisData,
    errorAverage,
  } = options;
  if (chartDom) {
    var myChart = echarts.init(chartDom);

    let option = {
      title: {
        text: name,
        textStyle: {
          fontSize: `${setSize(14)}px`,
          color: "#fff",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: legend,
        icon: "line",
        top: "15%",
        right: "1%",
        itemWidth: 12,
        textStyle: {
          color: "#fff",
          fontSize: `${setSize(10)}px`,
        },
      },
      color: ["#00E7FF", "#FFD643"],
      grid: {
        left: "3%",
        right: "7%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: {
        show: false,
      },

      xAxis: {
        type: "category",
        boundaryGap: false,
        data: xAxisData,
        axisLabel: {
          fontSize: `${setSize(14)}px`,
          fontFamily: "RobotoCondensed-Regular",
          color: "#fff",
        },
        axisTick: {
          show: true,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#74778C",
            width: 0.2,
            type: "solid",
          },
        },
      },
      yAxis: {
        type: "value",

        axisLabel: {
          fontSize: `${setSize(14)}px`,
          fontFamily: "RobotoCondensed-Regular",
          color: "#fff",
        },
        max: 8,
        splitLine: {
          show: true,
          lineStyle: {
            color: "#74778C",
            width: 0.2,
            type: "solid",
          },
        },
      },
      scale: true,
      series: [
        {
          name: legend[0],
          type: "line",
          smooth: false,
          symbolSize: 1,
          lineStyle: {
            fontFamily: "RobotoCondensed-Regular",
            width: setSize(1),
          },
          emphasis: {
            lineStyle: {
              width: setSize(1),
            },
          },
          data: xData,
          markLine: {
            data: [
              {
                yAxis: average,
                lineStyle: {
                  color: "#EBB93D",
                },
                label: {
                  show: true,
                  position: "end",
                  // fontSize: `${setSize(14)}px`,
                  fontSize: "12px",
                  color: "#EBB93D",
                  borderType: "dotted",
                },
              },
              {
                yAxis: errorAverage,
                lineStyle: {
                  color: "red",
                },
                label: {
                  show: true,
                  position: "end",
                  // fontSize: `${setSize(14)}px`,
                  fontSize: "12px",
                  color: "red",
                  borderType: "dotted",
                },
              },
            ],
            symbol: ["none", "none"],
            position: "insideTopCenter",

            label: {
              show: true,
              position: "end",
              // fontSize: `${setSize(14)}px`,
              fontSize: "12px",
              color: "red",
              borderType: "dotted",
            },
          },
        },
        {
          name: legend[1],
          type: "line",
          smooth: false,
          symbolSize: 1,
          lineStyle: {
            fontFamily: "RobotoCondensed-Regular",
            width: setSize(1),
          },
          emphasis: {
            lineStyle: {
              width: setSize(1),
            },
          },
          data: yData,
        },
      ],
    };

    option && myChart.setOption(option);
  }
};

/* VSD420折线图 */
const VSD706LineChart = (options) => {
  let {
    chartDom,
    name,
    legend,
    xData,
    yData,
    yData1,
    yData2,
    average,
    xAxisData,
    errorAverage,
  } = options;
  var myChart = echarts.init(chartDom);

  let option = {
    title: {
      text: name,
      textStyle: {
        fontSize: `${setSize(14)}px`,
        color: "#fff",
      },
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      data: legend,
      icon: "line",
      top: "15%",
      right: "1%",
      itemWidth: 12,
      textStyle: {
        color: "#fff",
        fontSize: `${setSize(10)}px`,
      },
    },
    color: ["#00E7FF", "#FFD643", "#BD83D6", "#5EE2BD"],
    grid: {
      left: "3%",
      right: "7%",
      bottom: "3%",
      containLabel: true,
    },
    toolbox: {
      show: false,
    },

    xAxis: {
      type: "category",
      boundaryGap: false,
      data: xAxisData,
      axisLabel: {
        fontSize: `${setSize(14)}px`,
        fontFamily: "RobotoCondensed-Regular",
        color: "#fff",
      },
      axisTick: {
        show: true,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#74778C",
          width: 0.2,
          type: "solid",
        },
      },
    },
    yAxis: {
      type: "value",

      axisLabel: {
        fontSize: `${setSize(14)}px`,
        fontFamily: "RobotoCondensed-Regular",
        color: "#fff",
      },
      min: 8,
      splitLine: {
        show: true,
        lineStyle: {
          color: "#74778C",
          width: 0.2,
          type: "solid",
        },
      },
    },
    scale: true,
    series: [
      {
        name: legend[0],
        type: "line",
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },
        data: xData,
        markLine: {
          data: [
            {
              yAxis: average,
              lineStyle: {
                color: "#EBB93D",
              },
              label: {
                show: true,
                position: "end",
                // fontSize: `${setSize(14)}px`,
                fontSize: "12px",
                color: "#EBB93D",
                borderType: "dotted",
              },
            },
            {
              yAxis: errorAverage,
              lineStyle: {
                color: "red",
              },
              label: {
                show: true,
                position: "end",
                // fontSize: `${setSize(14)}px`,
                fontSize: "12px",
                color: "red",
                borderType: "dotted",
              },
            },
          ],
          symbol: ["none", "none"],
          position: "insideTopCenter",

          label: {
            show: true,
            position: "end",
            // fontSize: `${setSize(14)}px`,
            fontSize: "12px",
            color: "red",
            borderType: "dotted",
          },
        },
      },
      {
        name: legend[1],
        type: "line",
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },
        data: yData,
      },
      {
        name: legend[2],
        type: "line",
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },
        data: yData1,
      },
      {
        name: legend[3],
        type: "line",
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },
        data: yData2,
      },
    ],
  };

  option && myChart.setOption(option);
};
/* 折线图 */
const lineChart = (options) => {
  let { chartDom, name, legend, colors, data, average, xAxisData } = options;

  var myChart = echarts.init(chartDom);

  let option = {
    title: {
      text: name,
      textStyle: {
        fontSize: `${setSize(14)}px`,
        color: "#fff",
      },
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      data: [legend],
      position: "top",
      icon: "line",
      top: "5%",
      right: "6%",
      itemWidth: 12,
      textStyle: {
        color: "#fff",
        fontSize: `${setSize(10)}px`,
      },
    },
    color: colors,
    grid: {
      left: "3%",
      right: "6%",
      bottom: "3%",
      containLabel: true,
    },
    toolbox: {
      show: false,
    },

    xAxis: {
      type: "category",
      boundaryGap: false,
      data: xAxisData,
      axisLabel: {
        interval: 1,
        fontSize: `${setSize(14)}px`,
        fontFamily: "RobotoCondensed-Regular",
        color: "#fff",
      },
      axisTick: {
        show: true,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#74778C",
          width: 0.2,
          type: "solid",
        },
      },
    },
    yAxis: {
      type: "value",
      min: 12,
      max: 18,
      axisLabel: {
        fontSize: `${setSize(14)}px`,
        fontFamily: "RobotoCondensed-Regular",
        color: "#fff",
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#74778C",
          width: 0.2,
          type: "solid",
        },
      },
    },
    scale: true,

    series: [
      {
        name: legend,
        type: "line",
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },
        data: data,
        markLine: {
          data: [{ yAxis: average }],
          symbol: ["none", "none"],
          position: "insideTopCenter",
          lineStyle: {
            color: "red",
          },
          label: {
            show: true,
            position: "end",
            fontSize: "12px",
            color: "red",

            borderType: "dotted",
          },
        },
      },
    ],
  };

  option && myChart.setOption(option);
};
/* 折线图 */
const linesChart = (options) => {
  let { chartDom, name, legend, colors, data, average, xAxisData } = options;

  var myChart = echarts.init(chartDom);

  let option = {
    title: {
      text: name,
      textStyle: {
        fontSize: `${setSize(14)}px`,
        color: "#fff",
      },
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      data: legend,
      position: "top",
      icon: "line",
      top: "10%",
      right: "6%",
      itemWidth: 12,
      textStyle: {
        color: "#fff",
        fontSize: `${setSize(10)}px`,
      },
    },
    color: colors,
    grid: {
      left: "3%",
      right: "6%",
      bottom: "3%",
      containLabel: true,
    },
    toolbox: {
      show: false,
    },

    xAxis: {
      type: "category",
      boundaryGap: false,
      data: xAxisData,
      axisLabel: {
        interval: 1,
        fontSize: `${setSize(14)}px`,
        fontFamily: "RobotoCondensed-Regular",
        color: "#fff",
      },
      axisTick: {
        show: true,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#74778C",
          width: 0.2,
          type: "solid",
        },
      },
    },
    yAxis: {
      type: "value",
      min: 12,
      max: 18,
      axisLabel: {
        fontSize: `${setSize(14)}px`,
        fontFamily: "RobotoCondensed-Regular",
        color: "#fff",
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#74778C",
          width: 0.2,
          type: "solid",
        },
      },
    },
    scale: true,

    series: data.map((item, index) => {
      return {
        name: legend[index],
        type: "line",
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },
        data: item,
        markLine: {
          data: [{ yAxis: average }],
          symbol: ["none", "none"],
          position: "insideTopCenter",
          lineStyle: {
            color: "red",
          },
          label: {
            show: true,
            position: "end",
            fontSize: "12px",
            color: "red",

            borderType: "dotted",
          },
        },
      };
    }),
  };

  option && myChart.setOption(option);
};
const linesRelationChart = (chartDom, name, legend, data) => {
  var myChart = echarts.init(chartDom);
  var option;

  option = {
    title: {
      text: name + "(A)",
      textStyle: {
        fontSize: `${setSize(14)}px`,
        color: "#fff",
      },
    },
    grid: {
      bottom: 40,
      left: "8%",
      right: "7%",
    },

    tooltip: {
      trigger: "axis",

      axisPointer: {
        type: "cross",
        animation: false,
        label: {
          backgroundColor: "#505765",
        },
      },
    },
    legend: {
      data: [legend + "(A)"],
      position: "top",
      icon: "line",
      top: "10%",
      right: "2%",
      itemWidth: 12,
      textStyle: {
        color: "#fff",
        fontSize: `${setSize(10)}px`,
      },
    },

    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        axisLine: { onZero: false },
        // prettier-ignore
        data: data.date,
        axisLabel: {
          fontSize: `${setSize(14)}px`,
          fontFamily: "RobotoCondensed-Regular",
          color: "#fff",
        },
      },
    ],
    yAxis: [
      {
        name: legend + "(A)",
        type: "value",
        min: 30,
        max: 40,
        axisLabel: {
          interval: 1,
          fontSize: `${setSize(14)}px`,
          fontFamily: "RobotoCondensed-Regular",
          color: "#fff",
        },
        nameTextStyle: {
          color: "#FFFFFF00",
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#74778C",
            width: 0.2,
            type: "solid",
          },
        },
      },
    ],
    series: [
      {
        name: legend + "(A)",
        type: "line",
        color: ["#00E7FF"],
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },
        // prettier-ignore
        data: data.data1,
      },
    ],
  };

  option && myChart.setOption(option);
};
/**
 *
 * @param {*} arr 数据数组
 * @returns 得到最大值或者最小值
 */
function findYAxisMinMax(arr) {
  let reslut = {};
  if (arr[0] || arr[0] == 0) {
    var boundaryGapMin = Math.min(...arr);
    var boundaryGapMax = Math.max(...arr);
    var diff = boundaryGapMax - boundaryGapMin;
    // 获取到最小值，最大值
    if (diff > 0 && boundaryGapMax > 0 && boundaryGapMin > 0) {
      //正常数据
      reslut = {
        key: "max",
        value: Math.ceil(boundaryGapMax + boundaryGapMin),
      };
    } else if (diff > 0 && boundaryGapMax > 0 && boundaryGapMin == 0) {
      //最小值为0时
      reslut = {
        key: "max",
        value: Math.ceil(boundaryGapMax + boundaryGapMax),
      };
    } else if (diff > 0 && boundaryGapMax > 0 && boundaryGapMin < 0) {
      //有正有负
      reslut = {}; //
    } else if (diff == 0) {
      //数据相等

      if (boundaryGapMax > 0 && boundaryGapMin > 0) {
        //正数
        reslut = {
          key: "max",
          value: Math.ceil(boundaryGapMax + boundaryGapMin),
        };
      } else {
        //负数
        reslut = {
          key: "min",
          value: Math.ceil(boundaryGapMax + boundaryGapMin),
        };
      }
    } else {
      //数据都为负数
      reslut = {
        key: "min",
        value: Math.ceil(boundaryGapMax + boundaryGapMin),
      };
    }
  }

  return reslut;
}


/**
operationThresholdHigh//可运行高
operationThresholdLow//可运行低
standardThresholdHigh //理想高
standardThresholdLow//理想低
 * @param {*} info 测点信息
 */
const markLinePaperMaking = (info)=> {
  //#FD0100  #FBDB0F
  let data = []

  if (info.operationThresholdLow&&info.standardThresholdLow&&info.standardThresholdHigh&&info.operationThresholdHigh) {
    
    if(info.operationThresholdLow == info.standardThresholdLow){
      data.push({            
        yAxis: info.operationThresholdLow,
        lineStyle: {
        color: '#FD0100'
      }})
    }else{
      data.push({            
        yAxis: info.operationThresholdLow,
        lineStyle: {
        color: '#FD0100'
      }})
      data.push({            
        yAxis: info.standardThresholdLow,
        lineStyle: {
        color: '#FBDB0F'
      }})
    }
    if(info.standardThresholdHigh == info.operationThresholdHigh){
      data.push({           
        yAxis: info.operationThresholdHigh,
        lineStyle: {
        color: '#FD0100'
      }})
    }else{
      data.push({            
        yAxis: info.standardThresholdHigh,
        lineStyle: {
        color: '#FBDB0F'
      }})
      data.push({            
        yAxis: info.operationThresholdHigh,
        lineStyle: {
        color: '#FD0100'
      }})
    }
  }
  
  return data;
}
const linesRelationsChart = (domData) => {
  var { chartDom, name, legend, data, info } = domData;
  // 获取当前DOM元素上的echarts实例
var myChartAsset = echarts.getInstanceByDom(chartDom);

// 如果实例存在，销毁它
// if (myChartAsset) {
//   myChartAsset.dispose();

// }

var markLine = {
  label:{
    show:false,
  },
  symbol: 'none', // 去掉箭头和圆点
} //辅助线

if(store.state.equipManagement.isDemonstrationPaperMaking){
  markLine['data'] = markLinePaperMaking(info)
}
var myChart = myChartAsset||echarts.init(chartDom);
    var option;

    option = {
      title: {
        text: name,
        textStyle: {
          fontSize: `${setSize(14)}px`,
          color: "#fff",
        },
      },
      grid: {
        bottom: 40,
        left: "14%",
        right: "3%",
      },

      tooltip: {
        trigger: "axis",
        confine: true, //是否将 tooltip 框限制在图表的区域内。
        axisPointer: {
          type: "cross",
          animation: false,
          label: {
            backgroundColor: "#00e7ff",
          },
        },
      },
      legend: {
        data: [legend],
        position: "top",
        icon: "line",
        top: "10%",
        right: "2%",
        itemWidth: 12,
        textStyle: {
          color: "#fff",
          fontSize: `${setSize(10)}px`,
        },
        show: false,
      },

      xAxis: [
        {
          type: "category",
          boundaryGap: ["0%", "20%"],
          axisLine: { onZero: false },
          // prettier-ignore
          data: data.date,
          axisLabel: {
            fontSize: `${setSize(14)}px`,
            fontFamily: "RobotoCondensed-Regular",
            color: "#fff",
          },
        },
      ],
      yAxis: [
        {
          name: legend + "(kPaG)",
          type: "value",
          // boundaryGap: ['0','100%'], //坐标轴两边留白策略
          axisLabel: {
            interval: 1,
            fontSize: `${setSize(14)}px`,
            fontFamily: "RobotoCondensed-Regular",
            color: "#fff",
          },
          nameTextStyle: {
            color: "#FFFFFF00",
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#74778C",
              width: 0.2,
              type: "solid",
            },
          },
        },
      ],
      series: [
        {
          name: legend,
          type: "line",
          color: ["#00e7ff"],
          smooth: false,
          // symbolSize: 1,
          symbolSize: (value, params) => {
            let size = 1;
            if (params.dataIndex == data.data1.length - 1) {
              //设置组后一个值明显
              size = 4;
            }
            return size;
          },
          lineStyle: {
            fontFamily: "RobotoCondensed-Regular",
            width: setSize(1),
          },
          emphasis: {
            lineStyle: {
              width: setSize(1),
            },
          },
          // 给最后一个值添加标注
          markPoint: {
            data: [
              {
                value:
                  data.data1[data.data1.length - 1] &&
                  Number(data.data1[data.data1.length - 1].toFixed(3)),
                xAxis: data.date[data.date.length - 1],
                yAxis: data.data1[data.data1.length - 1],
                symbolSize: (e, e1) => {
                  //通过最后一个值的length设置标注的大小
                  let size = 50;
                  if (e.toString().length > 4) {
                    size = e.toString().length * 12.5;
                  }
                  return Number(size.toFixed(3));
                },
              },
            ],
          },
          // prettier-ignore
          data: data.data1,
          markLine,
        },
      ],
    };

    /* 设置最大值或最小值，使折线居中显示 */
    let minMax = findYAxisMinMax(data.data1);

    if (minMax) {
      option.yAxis[0][minMax.key] = minMax.value;
    }

    option&&myChart&& myChart.setOption(option);
    option&&myChart&&myChart.resize();
};
const linesRelation212Chart = (chartDom, name, legend, data) => {
  var myChart = echarts.init(chartDom);
  var option;

  option = {
    title: {
      text: name,
      textStyle: {
        fontSize: `${setSize(14)}px`,
        color: "#fff",
      },
    },
    grid: {
      bottom: 50,
      left: "15%",
      right: "9%",
    },

    tooltip: {
      trigger: "axis",

      axisPointer: {
        type: "cross",
        animation: false,
        label: {
          backgroundColor: "#505765",
        },
      },
    },
    legend: {
      data: ["1#" + legend, "2#" + legend],
      position: "top",
      icon: "line",
      top: "10%",
      right: "2%",
      itemWidth: 12,
      textStyle: {
        color: "#fff",
        fontSize: `${setSize(10)}px`,
      },
    },

    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        axisLine: { onZero: false },
        // prettier-ignore
        data: data.date,
        axisLabel: {
          fontSize: `${setSize(14)}px`,
          fontFamily: "RobotoCondensed-Regular",
          color: "#fff",
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        axisLabel: {
          fontSize: `${setSize(14)}px`,
          fontFamily: "RobotoCondensed-Regular",
          color: "#fff",
        },
        nameTextStyle: {
          color: "#FFFFFF00",
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#74778C",
            width: 0.2,
            type: "solid",
          },
        },
      },
      {
        type: "value",
        axisLabel: {
          fontSize: `${setSize(14)}px`,
          fontFamily: "RobotoCondensed-Regular",
          color: "#fff",
        },
        nameTextStyle: {
          color: "#FFFFFF00",
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#74778C",
            width: 0.2,
            type: "solid",
          },
        },
      },
    ],
    series: [
      {
        name: "1#" + legend,
        type: "line",
        color: ["#00E7FF"],
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },
        // prettier-ignore
        data: data.data1,
      },
      {
        name: "2#" + legend,
        type: "line",
        color: ["#FFD643"],
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },
        // prettier-ignore
        data: data.data2,
      },
    ],
  };

  option && myChart.setOption(option);
};
const linesRelations212Chart = (chartDom, name, label, data) => {
  var myChart = echarts.init(chartDom);
  var option;

  option = {
    title: {
      text: name,
      textStyle: {
        fontSize: `${setSize(14)}px`,
        color: "#fff",
      },
    },
    grid: {
      bottom: 40,
      left: "15%",
      right: "9%",
      top: "35%",
    },

    tooltip: {
      trigger: "axis",

      axisPointer: {
        type: "cross",
        animation: false,
        label: {
          backgroundColor: "#505765",
        },
      },
    },
    legend: {
      data: [`${label.label1}(kPaA)`, `${label.label2}(℃)`],
      position: "top",
      icon: "line",
      top: "10%",
      right: "5%",
      itemWidth: 10,
      textStyle: {
        color: "#fff",
        fontSize: `${setSize(10)}px`,
      },
    },

    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        axisLine: { onZero: false },
        // prettier-ignore
        data: data.date,
        axisLabel: {
          fontSize: `${setSize(14)}px`,
          fontFamily: "RobotoCondensed-Regular",
          color: "#fff",
        },
      },
    ],
    yAxis: [
      {
        name: `${label.label1}(kPaA)`,
        type: "value",
        axisLabel: {
          interval: 1,
          fontSize: `${setSize(14)}px`,
          fontFamily: "RobotoCondensed-Regular",
          color: "#fff",
        },
        nameTextStyle: {
          color: "#FFFFFF",
        },
      },
      {
        name: `${label.label2}(℃)`,
        alignTicks: true,
        type: "value",
        axisLabel: {
          interval: 1,
          fontSize: `${setSize(14)}px`,
          fontFamily: "RobotoCondensed-Regular",
          color: "#fff",
        },
        nameTextStyle: {
          color: "#FFFFFF",
        },
      },
    ],
    series: [
      {
        name: `${label.label1}(kPaA)`,
        type: "line",
        color: ["#00E7FF"],
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },

        // prettier-ignore
        data: data.data1,
      },
      {
        name: `${label.label2}(℃)`,
        color: ["#FFD643"],
        yAxisIndex: 1,
        type: "line",
        smooth: false,
        symbolSize: 1,
        lineStyle: {
          fontFamily: "RobotoCondensed-Regular",
          width: setSize(1),
        },
        emphasis: {
          lineStyle: {
            width: setSize(1),
          },
        },

        // prettier-ignore
        data: data.data2,
      },
    ],
  };

  option && myChart.setOption(option);
};
/* 折线图 */
const HighlineChart = (options) => {
  var chartDom = document.getElementById(options.chartDom);
  var myChart = echarts.init(chartDom);
  var option;
  // let base = +new Date(2022, 7, 3);
  // let oneDay = 1300000;
  option = {
    tooltip: {
      trigger: "axis",
      position: function (pt) {
        return [pt[0], "10%"];
      },
    },
    title: {
      text: options.name + options.nameType,
      textStyle: {
        fontSize: `${setSize(14)}px`,
        color: "#ffffff",
      },
    },
    grid: {
      left: "10%",
      right: "6%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: options.date,
      axisLabel: {
        //y轴文字的配置
        textStyle: {
          color: "rgba(219,225,255,1)",
          margin: 15,
        },
        // formatter: '{value} %'//y轴的每一个刻度值后面加上‘%’号
      },
    },
    yAxis: {
      type: "value",
      max: options.max,
      min: options.min,
      splitLine: {
        //分割线配置
        show: true,
        lineStyle: {
          color: "rgba(219,225,255,0.5)",
        },
      },
      axisLabel: {
        //y轴文字的配置
        textStyle: {
          color: "rgba(219,225,255,1)",
          margin: 15,
        },
        // formatter: '{value} %'//y轴的每一个刻度值后面加上‘%’号
      },
    },
    series: [
      {
        name: options.name,
        type: "line",
        smooth: false,
        symbolSize: 1,
        itemStyle: {
          color: options.color,
        },
        lineStyle: {
          width: 1,
          color: options.color,
        },
        data: options.data,
        markLine: {
          symbol: "none",
          data: [
            {
              yAxis: options.threshold,
              label: {
                formatter: "{c}",
                position: "end",
                color: "#ED5E5E",
              },
              lineStyle: {
                color: "#ED5E5E",
              },
            },
          ],
        },
      },
    ],
  };
  // myChart.resize();
  option && myChart.setOption(option, true);
  window.addEventListener("resize", () => {
    myChart.resize();
  });
};

/* 气泡图 */

const PackedChart = (options) => {
  let { series, colors, filterValue, domDiv } = options;
  Highcharts.chart(domDiv, {
    accessibility: {
        enabled: false
    },
    chart: {
      type: "packedbubble",
      backgroundColor: "transparent",
      height: "100%",
    },
    title: {
      text: "",
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      useHTML: false,
      pointFormat: "",
    },
    plotOptions: {
      packedbubble: {
        // minSize: '30%',
        // maxSize: '150%',
        // zMin: 0,
        // zMax: 200,
        minSize: "30%",
        maxSize: "200%",
        zMin: 0,
        zMax: 100,
        layoutAlgorithm: {
          splitSeries: false,
          gravitationalConstant: 0.02,
        },
        dataLabels: {
          enabled: true,
          format: "{point.name}",
          filter: {
            property: "y",
            operator: ">",
            /*value的参数与数据value的值是对应的，值大于（operator符号）则显示title */
            value: filterValue,
          },
          style: {
            color: "#fff",
            textOutline: "none",
            fontSize: 13,
            fontWeight: "normal",
          },
        },
      },
    },
    colors: colors,
    series: series,
  });
};

export {
  getCurrentMonthDate,
  getBrowserLang,
  showTitle,
  setSize,
  VSD420LineChart,
  lineChart,
  HighlineChart,
  linesChart,
  linesRelationChart,
  linesRelationsChart,
  VSD706LineChart,
  linesRelations212Chart,
  linesRelation212Chart,
  PackedChart,
};
